import { styled } from "@mui/material";

const ArrowsWrapper = styled("div")({
  display: "flex",
  flexDirection: "column",
  gap: 0,
  color: "white",
});

export const WhiteDoubleArrow = () => (
  <ArrowsWrapper>
    <svg width="24" height="28" viewBox="0 0 24 28" fill="white">
      <path transform="translate(0, -2) rotate(180 12 12)" d="M7 10l5 5 5-5z" />
      <path transform="translate(0, 6)" d="M7 10l5 5 5-5z" />
    </svg>
  </ArrowsWrapper>
);
